module.exports = __webpack_public_path__ + "img/checkbox-blue-active.51b71e5e.svg";